import React, { Component } from "react";
import Popup from "./modules/Popup";
import Navbar from "./modules/Navbar";
import Hero from "./modules/Hero";
import About from "./modules/About";
import About2 from "./modules/About2";
import Categories from "./modules/Categories";
import Prizes from "./modules/Prizes";
import Timeline from "./modules/Timeline";
import Training from "./modules/Training";
import Partners from "./modules/Partners";
import Register from "./modules/Register";
import Gallery from "./modules/Gallery";
import Video from "./modules/Video";
import Faq from "./modules/Faq";
import Contact from "./modules/Contact";
import Footer from "./modules/Footer";
import ScrollButton from "./modules/ScrollButton";
import { Helmet } from "react-helmet";
import "./scss/App.scss";

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.title =
      "I’m the Best Coder! Challenge Campus Edition 2020 | Data Analytics Competition By Shopee";
    this.desc =
      "Join I'm the Best Coder! Challenge Campus Edition 2020, the largest data analytics competition for undergraduates in Singapore, on 13 March 2020! Win from a pool of SGD 6,000 and opportunities to discuss full-time or internship opportunities at Shopee. Form a team of 2 to 4 members and participate with your fellow undergraduates pursuing a Bachelor’s Degree in any local university, including international students. The Best Coder Campus Edition is a one-day data analytics competition where coders and programmers alike collaborate to analyse complex problem statements and examine real datasets to solve real industry problems. This data analytics challenge aims to discover the most accurate and most efficient coder. The challenge is completely free and open to any undergraduate with an interest or passion for coding. Shortlisted participants would also stand a chance to attend exclusive training workshops specially organized by Shopee.";
    this.url = "https://careers.shopee.sg/bestcoder";
    this.imageURL =
      "https://careers.shopee.sg/bestcoder/images/bestcoder_cover.png";
  }
  render() {
    return (
      <div className="application">
        <Helmet
          title={this.title}
          titleAttribute={{ itemprop: "name", lang: "en" }}
          meta={[
            { name: "author", content: "Ken Huang" },
            { name: "description", content: this.desc },
            { name: "robots", content: "index, follow" },
            { property: "og:title", content: this.title },
            { property: "og:site_name", content: this.title },
            { property: "og:type", content: "website" },
            { property: "og:url", content: this.url },
            { property: "og:image", content: this.imageURL },
            { property: "og:description", content: this.desc }
          ]}
          link={[{ rel: "canonical", href: this.url }]}
          script={[
            {
              type: "application/ld+json",
              innerHTML: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Event",
                name: "I’m the Best Coder! Challenge Campus Edition 2020",
                description: this.desc,
                image: this.imageURL,
                startDate: "2020-03-13T00:00+08:00",
                endDate: "2020-03-13T23:59+08:00",
                url: this.url,
                Performer: "Shopee Singapore",
                audience: {
                  audienceType:
                    "Students and Professionals passionate about Data!",
                  "@type": "EducationalAudience",
                  educationalRole: "Students passionate about Data analytic"
                },
                location: {
                  "@type": "Place",
                  name: "University Sports Centre, NUS ",
                  address:
                    "2 Sports Drive 1, National University of Singapore, Singapore 117561",
                  hasMap: "https://goo.gl/maps/mp7uGNfx928AG6688"
                },
                offers: {
                  "@type": "Offer",
                  price: "3000",
                  url: this.url,
                  priceCurrency: "SGD",
                  availability: "http://schema.org/InStock",
                  validFrom: "2019-10-20"
                }
              })
            }
          ]}
        />
      </div>
    );
  }
}

class App extends Component {
  render() {
    return (
      <div className="App">
        <Popup />
        <Application />
        <Navbar />
        <ScrollButton scrollStepInPx="150" delayInMs="0.66" />
        <Hero />
        <About />
        <About2 />
        {/* <Categories /> */}
        <Prizes />
        <Timeline />
        <Training />
        {/* <Register /> */}
        <Faq />
        <Partners />
        <Contact />
        <Gallery />
        <Video />
        <Footer />
      </div>
    );
  }
}

export default App;
